// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__32hZz","dragIcon":"SortableItem_dragIcon__3FbcW","disabled":"SortableItem_disabled__1PRI3"};